export const CAREER_VACANCY_PATH = "/career/:id";
